import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal } from "antd";
import backButton from '../../assets/images/back_button_arrow.svg';
import { SearchOutlined } from '@ant-design/icons';
import demandIcon from '../../assets/images/icons/demand_icon.svg';

function resetFormView() { };

const { Option } = Select;

const ThirdForm = ({ handlePageViewChange }) => {

    const [searchValue, setSearchValue] = useState('');
    const [filterApply, setFilterApply] = useState({
        publisher: [],
    });

    const { TextArea } = Input;

    const options = [
        { value: 'jack1', label: 'Jack 1' },
        { value: 'lucy1', label: 'Lucy 1' },
        { value: 'lucy8', label: 'Lucy 8' },
        { value: 'tom8', label: 'Tom 8' },
        { value: 'jack9', label: 'Jack 9' },
        { value: 'lucy9', label: 'Lucy 9' },
        { value: 'tom9', label: 'Tom 9' },
    ];

    const handleSearch = (e) => {
        setSearchValue(e.target.value.toLowerCase());
    };

    const onChange = (value) => {
        console.log(`Selected: ${value}`);
    };

    const handleFilterApply = (type, value) => {
        setFilterApply((prev) => {
            const currentPublishers = prev.publisher;
            const isSelected = currentPublishers.includes(value);

            // Toggle selection
            const updatedPublishers = isSelected
                ? currentPublishers.filter((item) => item !== value)
                : [...currentPublishers, value];

            return { ...prev, publisher: updatedPublishers };
        });
    };

    // Filtering options based on search input
    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(searchValue)
    );

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}>
                                <img src={demandIcon} alt="USP" /> GAM
                            </Link>
                        </li>
                        <li>Campaign</li>
                        <li className="primary">New Campaign</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between align-items-center">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }} />
                        <h1 className="heading"> Create Campaign </h1>
                    </div>
                    <div className='li_tabs_designs'>
                        <ul>
                            <li className='active_li_tab completed_li_tab'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 5.625V6.875" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 13.125V14.375" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.125 13.125H10.9375C11.3519 13.125 11.7493 12.9604 12.0424 12.6674C12.3354 12.3743 12.5 11.9769 12.5 11.5625C12.5 11.1481 12.3354 10.7507 12.0424 10.4576C11.7493 10.1646 11.3519 10 10.9375 10H9.0625C8.6481 10 8.25067 9.83538 7.95765 9.54235C7.66462 9.24933 7.5 8.8519 7.5 8.4375C7.5 8.0231 7.66462 7.62567 7.95765 7.33265C8.25067 7.03962 8.6481 6.875 9.0625 6.875H11.875" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Budget
                            </li>
                            <li className=''>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M1.875 14.375V12.5859C1.875 8.09375 5.48437 4.39062 9.96875 4.375C11.0384 4.37089 12.0983 4.57801 13.0877 4.98449C14.077 5.39096 14.9764 5.98879 15.7342 6.74368C16.492 7.49857 17.0933 8.39565 17.5035 9.38346C17.9138 10.3713 18.125 11.4304 18.125 12.5V14.375C18.125 14.5408 18.0592 14.6997 17.9419 14.8169C17.8247 14.9342 17.6658 15 17.5 15H2.5C2.33424 15 2.17527 14.9342 2.05806 14.8169C1.94085 14.6997 1.875 14.5408 1.875 14.375Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 4.375V6.875" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.14844 10.3984L4.57031 11.0469" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.8516 10.3984L15.4297 11.0469" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.07812 15L13.4219 8.03906" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Optimization
                            </li>
                            <li className=''>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85787 14.1421 2.5 10 2.5C5.85787 2.5 2.5 5.85787 2.5 10C2.5 14.1421 5.85787 17.5 10 17.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.002 14.5C12.4872 14.5 14.502 12.4853 14.502 10C14.502 7.51472 12.4872 5.5 10.002 5.5C7.51667 5.5 5.50195 7.51472 5.50195 10C5.50195 12.4853 7.51667 14.5 10.002 14.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Targeting
                            </li>
                            {/* <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M2 3.73383V8.43381H6.69998" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.96616 12.3505C4.47406 13.7921 5.43673 15.0296 6.70911 15.8765C7.98149 16.7235 9.49465 17.1339 11.0206 17.0461C12.5466 16.9583 14.0026 16.3769 15.1694 15.3896C16.3362 14.4023 17.1506 13.0625 17.4897 11.5721C17.8289 10.0817 17.6745 8.52151 17.0498 7.12651C16.4251 5.73151 15.364 4.57732 14.0263 3.83783C12.6886 3.09834 11.1469 2.81363 9.6333 3.02658C8.11973 3.23953 6.71636 3.93861 5.63465 5.01849L2 8.43381" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Retargeting
                            </li> */}
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.4444 3H4.55556C3.69645 3 3 3.69645 3 4.55556V15.4444C3 16.3036 3.69645 17 4.55556 17H15.4444C16.3036 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.3036 3 15.4444 3Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.27799 8.44444C7.92233 8.44444 8.44466 7.92211 8.44466 7.27778C8.44466 6.63345 7.92233 6.11111 7.27799 6.11111C6.63366 6.11111 6.11133 6.63345 6.11133 7.27778C6.11133 7.92211 6.63366 8.44444 7.27799 8.44444Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16.9991 12.3333L13.1102 8.44444L4.55469 17" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Ads
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="container_box--content pt_20 form_scrollable_div_d2">
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Ad</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">Excluded Categories </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group mb-0">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">ADX Sensitive Categories </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Geo</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">Country </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">State </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group mb-0">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">City </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Devices and Browsers</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group">
                                                <label className="form_label">
                                                    App/ Sites
                                                </label>
                                                <Radio.Group className="form_radio equal_space">
                                                    <Radio className="radio_btn" value="Website">
                                                        Show on Both
                                                    </Radio>
                                                    <Radio className="radio_btn" value="Inapp">
                                                        Show in Apps
                                                    </Radio>
                                                    <Radio className="radio_btn" value="CTV">
                                                        Show on sites
                                                    </Radio>
                                                </Radio.Group>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">Devices </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                        <span className="form_label">
                                                            Non-empty device ID
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>

                                            <div className="form_content_block--group">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">Device Brands and Models </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>

                                            <div className="form_content_block--group">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">Operating systems </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group mb-0">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">Browsers </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>List Targeting</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={8}>
                                                    <Col span={7}>
                                                        <label className="form_label">IP Lists </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            // onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17} className='disabled_ant_select_d2'>
                                                        <label className="form_label invisible">IP Lists </label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                disabled
                                                                showSearch={false}
                                                                // placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={8}>
                                                    <Col span={7}>
                                                        <label className="form_label">Domain Lists </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            // onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17}>
                                                        <div className="form_content_block--group mb-0">
                                                            <label className="form_label invisible">IP Lists </label>
                                                            <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h --80 textarea_paddingY_d2' />
                                                            <span className="error_content"></span>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={8}>
                                                    <Col span={7}>
                                                        <label className="form_label">Domains List (File) </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            // onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17} className='disabled_ant_select_d2'>
                                                        <label className="form_label invisible">Domains List (File) </label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                disabled
                                                                showSearch={false}
                                                                // placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">Extended User List </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <label className="form_label">App Bundle Lists </label>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group">
                                                <Row gutter={8}>
                                                    <Col span={7}>
                                                        <label className="form_label">Site Ids List Mode </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            // onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17}>
                                                        <div className="form_content_block--group mb-0">
                                                            <label className="form_label invisible">Site Ids List Mode </label>
                                                            <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                            <span className="error_content"></span>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group">
                                                <Row gutter={8}>
                                                    <Col span={7}>
                                                        <label className="form_label">App Bundles List </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            // onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17}>
                                                        <div className="form_content_block--group mb-0">
                                                            <label className="form_label invisible">App Bundles List </label>
                                                            <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                            <span className="error_content"></span>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group">
                                                <Row gutter={8}>
                                                    <Col span={7}>
                                                        <label className="form_label">App Ids List </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            // onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17}>
                                                        <div className="form_content_block--group mb-0">
                                                            <label className="form_label invisible">App Ids List </label>
                                                            <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                            <span className="error_content"></span>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group ">
                                                <Row gutter={8}>
                                                    <Col span={7}>
                                                        <label className="form_label">Publishers List </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            // onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17}>
                                                        <div className="form_content_block--group mb-0">
                                                            <label className="form_label invisible">Publishers List </label>
                                                            <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                            <span className="error_content"></span>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                        <span className="form_label">
                                                            Non-empty publisher ID
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group mb-0">
                                                <Row gutter={8}>
                                                    <Col span={7}>
                                                        <label className="form_label">Tag Ids List </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            // onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17}>
                                                        <div className="form_content_block--group mb-0">
                                                            <label className="form_label invisible">Tag Ids List </label>
                                                            <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                            <span className="error_content"></span>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                    </div >
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        <button className="w_120_d2 btn btn_white_outline w_fit_content"> Back </button>
                        <button className="w_120_d2 btn btn_primary w_fit_content">Next</button>
                    </div>
                </div >
            </div >
        </>
    )
}

export default ThirdForm